import './index.css';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useCallback, useEffect } from 'react';
import { useMultipleRefs } from '@hh.ru/magritte-common-use-multiple-refs';
import { Divider } from '@hh.ru/magritte-ui-divider';

var styles = {"drop":"magritte-drop___Z10P4_8-0-4","drop-container":"magritte-drop-container___dbMt9_8-0-4","dropContainer":"magritte-drop-container___dbMt9_8-0-4","divider-container":"magritte-divider-container___ZCdDW_8-0-4","dividerContainer":"magritte-divider-container___ZCdDW_8-0-4","drop-footer":"magritte-drop-footer___v8ZEO_8-0-4","dropFooter":"magritte-drop-footer___v8ZEO_8-0-4","drop-space-300":"magritte-drop-space-300___41acH_8-0-4","dropSpace300":"magritte-drop-space-300___41acH_8-0-4","drop-space-400":"magritte-drop-space-400___XX1RM_8-0-4","dropSpace400":"magritte-drop-space-400___XX1RM_8-0-4","drop-padding":"magritte-drop-padding___xBiJO_8-0-4","dropPadding":"magritte-drop-padding___xBiJO_8-0-4","drop-space-600":"magritte-drop-space-600___6B1i0_8-0-4","dropSpace600":"magritte-drop-space-600___6B1i0_8-0-4","drop-with-footer":"magritte-drop-with-footer___CgBIV_8-0-4","dropWithFooter":"magritte-drop-with-footer___CgBIV_8-0-4","drop-enter":"magritte-drop-enter___4vEuH_8-0-4","dropEnter":"magritte-drop-enter___4vEuH_8-0-4","drop-exit":"magritte-drop-exit___brFjz_8-0-4","dropExit":"magritte-drop-exit___brFjz_8-0-4","drop-enter-active":"magritte-drop-enter-active___SQUog_8-0-4","dropEnterActive":"magritte-drop-enter-active___SQUog_8-0-4","drop-exit-active":"magritte-drop-exit-active___GB0ET_8-0-4","dropExitActive":"magritte-drop-exit-active___GB0ET_8-0-4","drop-animation-timeout":"magritte-drop-animation-timeout___uO7LF_8-0-4","dropAnimationTimeout":"magritte-drop-animation-timeout___uO7LF_8-0-4"};

const DropContainer = forwardRef(({ children, dividerState }, ref) => {
    const dividerRef = useRef(null);
    const showDividerRef = useRef(false);
    showDividerRef.current = dividerState !== 'hide';
    const contentContainerRef = useRef(null);
    const contentContainerRefMulti = useMultipleRefs(contentContainerRef, ref);
    const updateDividerVisibility = useCallback((showDivider) => {
        if (!contentContainerRef.current || !dividerRef.current) {
            return;
        }
        if (!showDivider) {
            dividerRef.current.style.visibility = 'hidden';
            return;
        }
        if (contentContainerRef?.current !== null && dividerRef.current) {
            const hasScroll = contentContainerRef.current.scrollHeight - contentContainerRef.current.clientHeight > 0;
            dividerRef.current.style.visibility = hasScroll ? 'visible' : 'hidden';
        }
    }, [contentContainerRef, dividerRef]);
    useEffect(() => {
        const observer = new ResizeObserver(() => {
            updateDividerVisibility(showDividerRef.current);
        });
        observer.observe(contentContainerRef.current);
        return () => observer.disconnect();
    }, [updateDividerVisibility]);
    useEffect(() => {
        updateDividerVisibility(showDividerRef.current);
        // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    }, [updateDividerVisibility, showDividerRef.current]);
    const props = showDividerRef.current
        ? {
            onScroll: ({ target }) => {
                const scrollableContainer = target;
                if (dividerRef.current && dividerState !== 'showWhenFullyScrolled') {
                    const scrollEnded = scrollableContainer.scrollTop +
                        scrollableContainer.offsetHeight -
                        scrollableContainer.scrollHeight ===
                        0;
                    dividerRef.current.style.visibility = scrollEnded ? 'hidden' : 'visible';
                }
            },
        }
        : {};
    return (jsxs(Fragment, { children: [jsx("div", { ref: contentContainerRefMulti, className: styles.dropContainer, ...props, children: children }), jsx("div", { ref: dividerRef, className: styles.dividerContainer, "data-qa": "drop-divider", children: jsx(Divider, {}) })] }));
});
DropContainer.displayName = 'DropContainer';

export { DropContainer as D, styles as s };
//# sourceMappingURL=DropContainer-Dxs1sGPq.js.map
